// import { Exercise, ExerciseCreateRequestGroupEnum } from "@api/entities";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import sessionStorage from 'redux-persist/lib/storage';
// import { ContextEnum } from "@enums/context.enum";
import { SelectableExerciseGroup } from "../utils/muscleGroups";
import { Exercise } from "src/api/entities";
import { ContextEnum } from "src/_shared/enums/context.enum";

export interface ExerciseUpdate {
    nameEdit: string;
    groupEdit: string;
    urlEdit: string;
}

export interface ExerciseCreateUpdate {
    name: string;
    group: string;
}
export interface ExerciseFilter {
    name?: string;
    group?: string;
}


export interface ExerciseState {
    exerciseCreate: ExerciseCreateUpdate;
    exerciseUpdate: ExerciseUpdate;
    exercise: Exercise;
    exerciseFilters: ExerciseFilter;
    context: ContextEnum;
    exercises: Exercise[];
}

const initialExerciseCreateUpdate: ExerciseCreateUpdate = {
    name: '',
    group: ''
};
const initialExerciseUpdate: ExerciseUpdate = {
    nameEdit: '',
    groupEdit: '',
    urlEdit: ''
};

const initialState: ExerciseState = {
    exerciseCreate: initialExerciseCreateUpdate,
    exerciseUpdate: initialExerciseUpdate,
    exerciseFilters: {
        group: "",
        name: ""
    },
    exercise: {},
    exercises: [],
    context: ContextEnum.CREATE
};

export const exercisePersistedConfig = {
    key: 'exercise',
    storage: sessionStorage,
    whitelist: ['exerciseCreate', 'exerciseUpdate', 'exercises', 'context', 'exercise'],
};

export const exerciseSlice = createSlice({
    name: "exercise",
    initialState: initialState,
    reducers: {
        saveValue(state, action: PayloadAction<{ key: keyof ExerciseCreateUpdate; value: string }>) {
            state.exerciseCreate[action.payload.key] = action.payload.value;
        },
        saveEditingValue(state, action: PayloadAction<{ key: keyof ExerciseUpdate; value: string }>) {
            state.exerciseUpdate[action.payload.key] = action.payload.value;
        },
        selectGroup(state, action: PayloadAction<{ selectedGroup: SelectableExerciseGroup }>) {
            if (state.context == ContextEnum.CREATE) {
                state.exerciseCreate.group = action.payload.selectedGroup.value;
            } else {
                state.exerciseUpdate.groupEdit = action.payload.selectedGroup.value;
            }
        },
        filterGroup(state, action: PayloadAction<{ selectedGroup: SelectableExerciseGroup }>) {
            state.exerciseFilters.group = action.payload.selectedGroup.value;
        },
        filterName(state, action: PayloadAction<{ searchTerm: string }>) {
            state.exerciseFilters.name = action.payload.searchTerm;
        },
        resetFilterGroup(state) {
            state.exerciseFilters.group = "";
        },
        resetFilters(state) {
            state.exerciseFilters = {
                 group: undefined,
                 name: undefined
            };
        },
        resetSelectGroup(state) {
                state.exerciseCreate.group = "";
        },
        setItems(state, action: PayloadAction<{ value: Exercise[] }>) {
            state.exercises = action.payload.value;
            state.exercises = state.exercises.sort((a, b) => a.name!.localeCompare(b.name!));
        },
        resetExerciseCreate(state) {
            state.exerciseCreate = initialExerciseCreateUpdate
        },
        setContext(state, action: PayloadAction<{ value: ContextEnum }>) {
            state.context = action.payload.value;
        },
        setItem(state, action: PayloadAction<{ value: Exercise }>) {
            state.exercise = action.payload.value;
            state.exerciseUpdate = {
                groupEdit: action.payload.value.group ?? "",
                nameEdit: action.payload.value.name ?? "",
                urlEdit: action.payload.value.url ?? ""
            }
        },
        resetItem(state) {
            state.exercise = {};
            state.exerciseUpdate = initialExerciseUpdate
        },
        deleteItem(state, action: PayloadAction<{ value: string }>) {
            state.exercises = [...state.exercises!.filter((exe) => exe.uuid !== action.payload.value)]
        }
    },
});

export const { 
    saveEditingValue,
    saveValue,
    resetExerciseCreate,
    selectGroup,
    resetSelectGroup,
    setItems,
    setContext,
    setItem,
    resetItem,
    deleteItem,
    filterName,
    filterGroup,
    resetFilterGroup,
    resetFilters
 } = exerciseSlice.actions;

export const exerciseReducer = exerciseSlice.reducer;
